module.exports = __webpack_public_path__ + "img/4.420a2721.jpg";